// @flow
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

type Props = {
  seconds: number
};

export const SessionExpiredDisplay = (props: Props) => (
  <Container>
    <h1>Session Expired</h1>
    {props.seconds === 0 ? (
      <p>Redirecting to login....</p>
    ) : (
      <p>
        You will be redirected to the login page in {props.seconds} seconds.
      </p>
    )}
  </Container>
);
